import React from 'react';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import { formatErrorMessage } from 'src/Pages/ItemDetailV2/utils';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';
import ErrorView from 'src/Components/ErrorViewV2';
import { ErrorViewType } from 'src/Components/ErrorViewV2/config';

const TransactionFailureModal = ({
  onClose,
  error
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  })), /*#__PURE__*/React.createElement(ErrorView, {
    config: {
      content: formatErrorMessage(error),
      title: 'OOPS!',
      type: ErrorViewType.Custom
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    title: "I got it"
  }))));
};

export default TransactionFailureModal;